import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getPublicSettings } from 'store/v1/public_settings/public_settings.actions.js';
import { getAvailabilityRequest } from 'store/availabilities/availabilities.actions.js';
import { closeBookingSidebar } from 'store/v1/ui/ui.actions.js';

import ResourcePortalHeader from './ResourcePortalHeader/ResourcePortalHeader';
import ResourcePortalBookingSidebar from './ResourcePortalBookingSidebar/ResourcePortalBookingSidebar';

import styles from './ResourcePortal.module.scss';
import CalendarRoute from './ResourcePortalRouter/CalendarRoute/CalendarRoute.jsx';
import { ParallaxBanner } from 'v5/patterns/widgets/ParallaxBanner/ParallaxBanner';

const ResourcePortal = ({ token, bearerToken }) => {
  const dispatch = useDispatch();
  const { settings } = useSelector(state => state.public_settings);
  const { showBookingSidebar, selectedBooking } = useSelector(
    state => state.ui
  );
  const { publicBrandImage, publicCompanyName, publicTeamName } = settings;
  const [isCalendarHintOpen, setIsCalendarHintOpen] = useState(false);

  useEffect(() => {
    const { teamSchema, availabilityRequestId } = token;
    dispatch(getPublicSettings(teamSchema, availabilityRequestId));
    dispatch(
      getAvailabilityRequest(teamSchema, availabilityRequestId, bearerToken)
    );
  }, []);

  return (
    <div className={styles['ResourcePortal']}>
      <ResourcePortalHeader
        imagePath={publicBrandImage}
        companyName={publicCompanyName}
        teamName={publicTeamName}
        onOpenCalendarHint={() => setIsCalendarHintOpen(true)}
      />
      <div className={styles['ResourcePortal__content']}>
        <CalendarRoute
          isMobileHintOpen={isCalendarHintOpen}
          onCloseMobileHint={() => setIsCalendarHintOpen(false)}
        />
        <ResourcePortalBookingSidebar
          isOpen={showBookingSidebar}
          closeSidebar={() => dispatch(closeBookingSidebar())}
          booking={selectedBooking}
        />
      </div>
      <ParallaxBanner />
    </div>
  );
};

ResourcePortal.props = {
  routesConfiguration: PropTypes.object,
  defaultRoute: PropTypes.object,
  token: PropTypes.object
};

export default ResourcePortal;
